

export class MachineRequestModel {
    id?: number;
    machineType: string;
     machine: string;

    constructor(
        machineType: string,
        machine: string,
        id?: number,
    ) {
        this.id = id;
        this.machineType = machineType;
        this.machine = machine

    }
}